import { render, staticRenderFns } from "./ProjectFaviconPicker.vue?vue&type=template&id=8331510e&"
import script from "./ProjectFaviconPicker.vue?vue&type=script&lang=js&"
export * from "./ProjectFaviconPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports